/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 19 2023
 **/

import { useState } from "react";
import { useTheme } from "@emotion/react";

import { Column, Radio, Row, Typography } from "@/frameworks/designStuff/components";
import { useProperties } from "@/frameworks/libraries/properties";
import { Maybe } from "@/frameworks/libraries/components";
import { _T } from "@rfice/language";

import * as S from "./emotion";

interface SpaceCardProps extends React.HTMLAttributes<HTMLDivElement> {
	data: WebServices.SpaceTheme.List.Item & { selectedSpaceThemeId?: string };
	checked: boolean;
}
export default function SpaceCardItem({ data, onClick, checked }: SpaceCardProps) {
	const theme = useTheme();
	const properties = useProperties();
	const [isHover, setIsHover] = useState(false);

	const isVideoReady = isHover && data.videoThumbnailPath !== "undefined";
	const isCurrent = data.selectedSpaceThemeId === data.id;
	return (
		<S.Layout
			type="outer"
			onClick={onClick}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			isCurrent={isCurrent}
		>
			<S.ImageWrapper>
				<Maybe test={isCurrent}>
					<S.Overlay horizonAlign="center" verticalAlign="center">
						<Typography typoSize="Head6" typoColor="neutral_00_100">
							{_T("현재 설정 맵")}
						</Typography>
					</S.Overlay>
				</Maybe>
				<S.Image src={data.thumbnailPath} />
				{isVideoReady && (
					<S.Video src={properties.default.webDomain + data.videoThumbnailPath} autoPlay muted />
				)}
			</S.ImageWrapper>
			<S.Content css={[S.textColorCss(theme)]} data-id={data.id}>
				<Row horizonAlign="distribute" verticalAlign="center" css={{ width: "100%" }}>
					<Column>
						<Typography typoSize="Title1" className="card__title">
							{data.name}
						</Typography>
						<Typography typoSize="Body5" className="card__desc">
							{_T("동시 접속 최대 {{maxUserCount}}명", { maxUserCount: data.maxUserCount })}
						</Typography>
					</Column>
					<Maybe test={data.selectedSpaceThemeId === data.id}>
						<Maybe.Fallback>
							<Radio
								id={data.id}
								name="radio-select-theme"
								onClick={onClick}
								onChange={() => {}}
								value={data.id}
								checked={checked}
							/>
						</Maybe.Fallback>
					</Maybe>
				</Row>
			</S.Content>
		</S.Layout>
	);
}
